export default class WikiLinks {
    constructor() {
        this.wikiLinks();
        this.wikiNav();
    }

    wikiLinks(){

            let wikiDataElement = document.querySelector(".wiki-data");

            if (!wikiDataElement) return;

            let wikiTitles = wikiDataElement.getAttribute("data-wiki").split(",");

            document.querySelectorAll("p").forEach((paragraph) => {

                let text = paragraph.innerHTML;

                if (paragraph.querySelector("a")) {
                    let walker = document.createTreeWalker(paragraph, NodeFilter.SHOW_TEXT, null, false);
                    let nodes = [];

                    while (walker.nextNode()) {
                        let node = walker.currentNode;

                        if (node.parentNode.nodeName === 'A') continue;

                        nodes.push(node);
                    }

                    nodes.forEach((node) => {
                        let replacedText = node.textContent;

                        wikiTitles.forEach((title) => {
                            let regex = new RegExp("\\b" + title + "\\b(?![^<]*>|[^<>]*</a>)", "gi");
                            const slug = title.toLowerCase().trim().replace(/\s+/g, '-');

                            const link = title.toLowerCase() === 'siyum'
                                ? `<a href="/what-is-a-siyum/" class="wiki_text">${title}</a>`
                                : `<a href="/terms/${encodeURIComponent(slug)}" class="wiki_text">${title}</a>`;

                            replacedText = replacedText.replace(regex, link);
                        });
                        const span = document.createElement('span');
                        span.innerHTML = replacedText;
                        node.parentNode.replaceChild(span, node);
                    });

                    return;
                }

                wikiTitles.forEach((title) => {
                    let regex = new RegExp("\\b" + title + "\\b(?![^<]*>|[^<>]*</a>)", "gi");
                    if(title.toLowerCase() == 'siyum'){
                        text = text.replace(regex, `<a href="/what-is-a-siyum/" class="wiki_text">${title}</a>`);
                    } else {
                        const slug = title.toLowerCase().trim().replace(/\s+/g, '-');
                        text = text.replace(regex, `<a href="/terms/${encodeURIComponent(slug)}" class="wiki_text">${title}</a>`);
                    }
                });

                paragraph.innerHTML = text;
            });

    }

    wikiNav() {
        $(document).ready(function () {
           const nav_items = $('.wiki-content-nav__item[data-title]')

            if(nav_items.length){
                $('.wiki-content-nav__item[data-title]').each(function () {
                    let index = $(this).data('index');
                    let item_id = $(this).attr('href').replace('#', '');

                    const listing_item = $(`.jet-listing-grid__item:has(#ac-trigger-${index})`);
                    listing_item.attr('id', item_id)
                })
            }

            $('.wiki-content-nav__item').click(function (e){
                e.preventDefault();
                let item_id = $(this).attr('href');

                let targetElement = $(item_id);

                $('html, body').animate({
                    scrollTop: targetElement.offset().top - 200
                }, 'smooth');

            })

        })
    }

}




